import React from 'react'
import styled, { css } from 'styled-components'

const width = '91'
const height = '108'
const viewBox = '0 0 91 108'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <defs key="key-0">
      <path
        id="s-ac15f6e907-b"
        d="M22.006.416C10.179.416.558 10.043.558 21.878c0 16.096 21.448 39.857 21.448 39.857s21.447-23.76 21.447-39.857c0-11.835-9.62-21.462-21.447-21.462z"
      />
      <filter
        id="s-ac15f6e907-a"
        width="279.5%"
        height="225.6%"
        x="-89.8%"
        y="-59.5%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="12.5"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.603870697 0 0 0 0 0.638313882 0 0 0 0 0.700627126 0 0 0 0.356289629 0"
        />
      </filter>
    </defs>,
    <g fill="none" fillRule="evenodd" transform="translate(23 22)" key="key-1">
      <g fillRule="nonzero">
        <use
          fill="#000"
          filter="url(#s-ac15f6e907-a)"
          xlinkHref="#s-ac15f6e907-b"
        />
        <use fill="#1E4F67" fillRule="evenodd" xlinkHref="#s-ac15f6e907-b" />
      </g>
      <ellipse cx="22.138" cy="21.462" fill="#EEF4F9" rx="10.327" ry="10.333" />
    </g>
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconMapPin'
})
